import { render, staticRenderFns } from "./Kick.vue?vue&type=template&id=772fd304"
import script from "./Kick.vue?vue&type=script&lang=js"
export * from "./Kick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports